<div class="mobile-menu">
	<button (click)="dismissMenu()" class="dismiss-btn" mat-icon-button>
		<mat-icon>close</mat-icon>
	</button>

	<div class="menu-section">
		<div class="mobile-nav-title">
			<mat-icon>description</mat-icon>
			<span>{{ "navigation.claims" | translate }}</span>
		</div>

		<button
			(click)="handleNavigate('/claims/dashboard')"
			*ngIf="isLoggedIn"
			[ngClass]="isActiveUrl('dashboard') ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<mat-icon>dashboard</mat-icon
			><span>{{ "navigation.dashboard" | translate }}</span>
		</button>
		<button
			(click)="handleNavigate('/policies')"
			*ngIf="isLoggedIn"
			[ngClass]="isActiveUrl('policies') ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<mat-icon>health_and_safety</mat-icon
			><span>{{ "navigation.policies" | translate }}</span>
		</button>
		<button
			(click)="handleNavigate('/claim-status')"
			*ngIf="isLoggedIn"
			[ngClass]="isActiveUrl('claim-status') ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<mat-icon>update</mat-icon
			><span>{{ "My Claims" | translate }}</span>
		</button>
		<button
			(click)="handleNavigate('/claims-submit')"
			[ngClass]="isActiveUrl('claims-submit') ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<mat-icon>assignment_add</mat-icon
			><span>{{ "Submit New Claim" | translate }}</span>
		</button>
		<button
			(click)="handleNavigate('/claims')"
			*ngIf="!isLoggedIn"
			[ngClass]="isActiveUrl('overview') ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<mat-icon>home</mat-icon
			><span>{{ "navigation.overview" | translate }}</span>
		</button>
	</div>

	<div *ngIf="isLoggedIn" class="menu-section">
		<div class="mobile-nav-title">
			<mat-icon>settings</mat-icon>{{ "navigation.settings" | translate }}
		</div>

		<button
			(click)="handleNavigate('/account/profile')"
			[ngClass]="isActiveUrl('profile') ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<mat-icon>person</mat-icon
			><span>{{ "navigation.profile" | translate }}</span>
		</button>
	</div>

	<div class="menu-section">
		<div class="mobile-nav-title">
			<mat-icon>translate</mat-icon>{{ "navigation.language" | translate }}
		</div>

		<button
			(click)="switch('en')"
			[ngClass]="selectedLanguage === 'en' ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<span>{{ "language.en" | translate }}</span>
		</button>
		<button
			(click)="switch('bm')"
			[ngClass]="selectedLanguage === 'bm' ? 'active-menu-button' : ''"
			mat-menu-item
		>
			<span>{{ "language.bm" | translate }}</span>
		</button>
	</div>

	<button (click)="handleLogout()" *ngIf="isLoggedIn" class="outline-btn mt-sm">
		<mat-icon>logout</mat-icon><span>{{ "common.logout" | translate }}</span>
	</button>

	<a *ngIf="!isLoggedIn" class="primary-btn mt-sm" href="authentication/login">
		<mat-icon>login</mat-icon><span>{{ "common.login" | translate }}</span>
	</a>
</div>
